/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';

import { Button, Icon, Segment } from '@mairistem/composants';

import type { Steps } from '@/types';

interface Props {
  /** Index de l'étape actuelle */
  currentStepIndex: number;
  /** Nombre total d'étapes */
  nbSteps: number;
  /** En chargement */
  loading: boolean;
  /** Callback appelé lors du changement d'étape */
  onStepChange: (stepIndex: Steps) => void;
  /** Callback appelé lors du clique sur le bouton 'Terminer' */
  onFinish: () => void;
}

const AssistantFooter = (props: Props) => {
  // #region Declarations
  const { currentStepIndex, onStepChange, onFinish, nbSteps, loading } = props;

  // #endregion

  // #region Component

  return (
    <Segment
      style={{
        display: 'flex',
        borderBottom: 'none',
        borderLeft: 'none',
        borderRight: 'none',
        background: 'transparent',
        boxShadow: 'none',
      }}
    >
      {currentStepIndex !== 0 && (
        <Button
          data-testid="assistant-etape-precedente"
          onClick={() => onStepChange(currentStepIndex - 1)}
          disabled={loading}
          loading={loading}
        >
          <Icon name="angle left" />
          Étape précédente
        </Button>
      )}
      <div style={{ flex: 1 }} />
      {currentStepIndex === nbSteps ? (
        <Button
          positive
          data-testid="assistant-terminer"
          onClick={onFinish}
          disabled={loading}
          loading={loading}
        >
          <Icon name="flag checkered" />
          Terminer
        </Button>
      ) : (
        <Button
          data-testid="assistant-etape-suivante"
          onClick={() => onStepChange(currentStepIndex + 1)}
          disabled={loading}
          loading={loading}
        >
          Étape suivante
          <Icon name="angle right" />
        </Button>
      )}
    </Segment>
  );
};

export default AssistantFooter;
